//Dashboard.js
import React, { Component } from 'react';
import axios from 'axios';
import { Navigate } from 'react-router-dom';
import Serverurl from './Apiurl';
import './styles/styles.css';
import {
    Container,
    Paper,
    Typography,
    Alert,
    CircularProgress
} from '@mui/material';
import { Link } from 'react-router-dom';
import {
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Button,
} from '@mui/material';
import dayjs from 'dayjs';
export default class Dashboard extends Component {
    constructor(props) {
        super(props);
        this.state = {
            redirect: false,
            pagename: '',
            ActiveProjects: 0,vendorPendingPayments: [],
            TotalExpenses: 0, materialPurchaseData: [],
            CustomerDue: 0,customerDueData: [],
            VendorDue: 0,dailyHeadCounts: [],   expenseMini: [],projectSummary: [],
dynamicColumns: [],
loading: false,
            error: ''
        };
    }
    apicall = () => {
        this.setState({
            loading: true,
            error: ''
        });
        axios
            .get(
                Serverurl +
                "ajaxdashboard.php?action=dashboardsummary"
            )
            .then((resp) => {
                if (resp.data && resp.data.length > 0) {
                    this.setState({
                        ActiveProjects: resp.data[0].ActiveProjects || 0,
                        TotalExpenses: resp.data[0].TotalExpenses || 0,
                        CustomerDue: resp.data[0].CustomerDue || 0,
                        VendorDue: resp.data[0].VendorDue || 0,
                        loading: false
                    });
                }
                else {
                    this.setState({
                        loading: false
                    });
                }
				
				this.fetchDailyHeadCounts();
            })
            .catch(() => {
                this.setState({
                    loading: false,
                    error: 'Unable to load dashboard data'
                });
            });
    };
    componentWillMount() {
       if(localStorage.getItem("VRuserid")===null)
		  {

		   this.setState({
            redirect: true,
			pagename:'/Userlogin'
          })
		  }
let strname="Dashboard";   
			 this.props.parentsCallback(
           strname
        );
		
		document.title = "VR Builders - Dashboard";
        this.apicall();
		
		
		
	
		this.fetchExpenseMini();
		this.fetchProjectSummary();
    }
	fetchProjectSummary = () => {
    axios
        .get(
            Serverurl +
            "ajaxdashboard.php?action=getprojectwisesummary"
        )
        .then((res) => {
            this.setState({
                projectSummary: Array.isArray(res.data) ? res.data : []
            });
        })
        .catch(() => {});
};
fetchExpenseMini = () => {
  axios
    .get(
      Serverurl +
        "ajaxexpenses.php?action=getexpensesall" +
        
        "&exp_pj_id=" +
        "" +
        "&exp_categoryname=" +
        "" +
        "&StartIndex=0" +
        "&PageSize=5" +
        "&sorting=exp.exp_id desc"
    )
    .then((res) => {
      this.setState({
        expenseMini: Array.isArray(res.data) ? res.data : []
      });
    })
    .catch(() => {});
};
	fetchMaterialPurchase = () => {
  axios
    .get(
      Serverurl +
        "ajaxmaterialprocurement.php?action=getmaterialpurchasereport" +
        "&index=0" +
        "&maxrecord=5" +
        "&orderby=mp_createddate DESC"
    )
    .then((res) => {
      this.setState({
        materialPurchaseData: Array.isArray(res.data) ? res.data : []
      });
    })
    .catch(() => {});
};
	fetchVendorPendingPayments = () => {
    axios
        .get(
            Serverurl +
            "ajaxvendorprojectpendingpayment.php?action=getall" +
            "&StartIndex=0" +
            "&PageSize=5" +
            "&sorting=paydate DESC"
        )
        .then((res) => {
            this.setState({
                vendorPendingPayments: Array.isArray(res.data) ? res.data : []
            });
				this.fetchMaterialPurchase();
        })
        .catch(() => {});
};
	fetchCustomerDue = () => {
    axios
        .get(
            Serverurl +
            "ajaxlaborexpensesreport.php?action=getprojectpaymentduereport" +
            "&project_id=0" +
            "&index=0" +
            "&maxrecrd=5" +
            "&orderby=Due DESC"
        )
        .then((resp) => {
            this.setState({
                customerDueData: resp.data || []
            });
			
			this.fetchVendorPendingPayments();
        })
        .catch(() => {});
};
fetchDailyHeadCounts = () => {
    axios
        .get(
            Serverurl +
            "ajaxlaborexpensesreport.php?action=dashboardwages" +
            "&index=0" +
            "&maxrecrd=5"
        )
        .then((resp) => {
            let dynamicColumns = [];
            if (resp.data.length > 0) {
                dynamicColumns = Object.keys(resp.data[0]).filter(
                    key =>
                        ![
                            "count",
                            "LabourDate",
                            "ProjectName",
                            "GrandTotalAmount"
                        ].includes(key)
                );
            }
            this.setState({
                dailyHeadCounts: resp.data || [],
                dynamicColumns
            });
			
			this.fetchCustomerDue();
        });
};
getUnitName = (unitId) => {
  switch (Number(unitId)) {
    case 1:
      return "Kgs";
    case 2:
      return "Nos";
    case 3:
      return "Loads";
    case 4:
      return "Meter";
    case 5:
      return "Litres";
    default:
      return "";
  }
};
    render() {
        if (this.state.redirect) {
            return <Navigate to={this.state.pagename} />;
        }
        return (
            <div>
                <div>                 
                    {
                        this.state.error &&
                        <Alert severity="error">
                            {this.state.error}
                        </Alert>
                    }
                    {
                        this.state.loading &&
                        <CircularProgress />
                    }
                    <div className="dashboard-row">
                        <div className="dashboard-box">
                            <div className="dashboard-title">
                                Active Projects
                            </div>
                            <div className="dashboard-value">
                                {this.state.ActiveProjects} +
                            </div>
                        </div>
                        <div className="dashboard-box">
                            <div className="dashboard-title">
                                Total Expenses
                            </div>
                            <div className="dashboard-value">
                                 Rs. {Number(
                                    this.state.TotalExpenses
                                ).toLocaleString('en-IN')}
                            </div>
                        </div>
                        <div className="dashboard-box">
                            <div className="dashboard-title">
                                Customer Due
                            </div>
                            <div className="dashboard-value">
                                Rs. {Number(
                                    this.state.CustomerDue
                                ).toLocaleString('en-IN')}
                            </div>
                        </div>
                        <div className="dashboard-box">
                            <div className="dashboard-title">
                                Vendor Due
                            </div>
                            <div className="dashboard-value">
                                Rs. {Number(
                                    this.state.VendorDue
                                ).toLocaleString('en-IN')}
                            </div>
                        </div>
                    </div>
					<div className="dashboard-table-section">

    <div className="dashboard-table-header">
        <h2 className="dashboard-table-title">
            Active Projects
        </h2>
    </div>

    <TableContainer component={Paper}>
        <Table>

            <TableHead>
                <TableRow>
                    <TableCell><b>Sl No</b></TableCell>
                    <TableCell><b>Project</b></TableCell>
                    <TableCell align="right"><b>Contract Value</b></TableCell>
                    <TableCell align="right"><b>Received</b></TableCell>
					 <TableCell align="right"><b>Outstanding</b></TableCell>
                   
                    <TableCell align="right"><b>Total Project Cost</b></TableCell>
                     <TableCell align="right"><b>Cost Paid</b></TableCell>
					       <TableCell align="right"><b>Cost Payable</b></TableCell>
				
                    <TableCell align="right"><b>Net Profit</b></TableCell>
                </TableRow>
            </TableHead>

            <TableBody>

                {
                    this.state.projectSummary.length === 0 ?
                        <TableRow>
                            <TableCell colSpan={10} align="center">
                                No Records Found
                            </TableCell>
                        </TableRow>
                        :
                        this.state.projectSummary.map((item, index) => { 
let paidcost=	parseFloat(item.VendorPayments)+parseFloat(item.Expenses)	;	
let Payable=	parseFloat(item.ActualExpense)-parseFloat(paidcost)	;				
           return (
						
						 <React.Fragment>
                            <TableRow key={index}>

                                <TableCell>{index + 1}</TableCell>

                                <TableCell>
                                    {item.ProjectName}
                                </TableCell>

                                <TableCell align="right">
                                    Rs. {Number(item.ProjectValue || 0).toLocaleString("en-IN")}
                                </TableCell>

                                <TableCell align="right">
                                    Rs. {Number(item.PaidAmount || 0).toLocaleString("en-IN")}
                                </TableCell>
 <TableCell
    align="right"
    sx={{
        color: Number(item.CustomerDue || 0) > 0 ? "red" : "inherit",
         
    }}
>
    Rs. {Number(item.CustomerDue || 0).toLocaleString("en-IN")}
</TableCell>
 <TableCell align="right">
                                    Rs. {Number(item.ActualExpense ).toLocaleString("en-IN")}
                                </TableCell>
                                
                               
 <TableCell align="right">
                                    Rs. {Number(paidcost).toLocaleString("en-IN")}
                                </TableCell>
								                               
 <TableCell align="right">
                                    Rs. {Number(Payable).toLocaleString("en-IN")}
                                </TableCell>
								
                             
<TableCell
    align="right"
    sx={{
        color:
            Number(item.NetProfit || 0) < 0
                ? "red"
                : "green",
        
    }}
>
 <b>   Rs. {Number(item.NetProfit || 0).toLocaleString("en-IN")}</b>
</TableCell>

                            </TableRow>
                         </React.Fragment>	
);
					})
                }

            </TableBody>

        </Table>
    </TableContainer>
  <div className="view-more-container">
	   <Link
            to="/ProjectLedgerReport"
            style={{
                textDecoration: "none"
            }}
        >
            <Button color="primary">
                VIEW MORE
            </Button>
        </Link>

    </div>
</div>
					<div className="dashboard-table-section full">
    <div className="dashboard-table-header">
        <h2 className="dashboard-table-title">
            Daily Head Counts
        </h2>
    </div>
    <TableContainer component={Paper}>
        <Table>
            <TableHead>
                <TableRow>
                    <TableCell>
                        <b>Sl No</b>
                    </TableCell>
                    <TableCell>
                        <b>Project Name</b>
                    </TableCell>
                    {
                        this.state.dynamicColumns.map((col) => (
                            <TableCell key={col}>
                                <b>{col}</b>
                            </TableCell>
                        ))
                    }
                    <TableCell >
                        <b>Grand Total</b>
                    </TableCell>
                </TableRow>
            </TableHead>
            <TableBody>
                {
                    this.state.dailyHeadCounts.length === 0 ?
                    <TableRow>
                        <TableCell
                            colSpan={
                                this.state.dynamicColumns.length + 4
                            }
                            align="center"
                        >
                            No Records Found
                        </TableCell>
                    </TableRow>
                    :
                    this.state.dailyHeadCounts.map((item, index) => (
                        <TableRow key={index}>
                            <TableCell>
                                {index + 1}
                            </TableCell>
                            <TableCell>
                                {item.ProjectName}
                            </TableCell>
                            {
                                this.state.dynamicColumns.map((col) => (
                                    <TableCell key={col}>
                                        {item[col]}
                                    </TableCell>
                                ))
                            }
                            <TableCell><b>
                                Rs. {Number(
                                    item.GrandTotalAmount || 0
                                ).toLocaleString("en-IN")}</b>
                            </TableCell>
                        </TableRow>
                    ))
                }
            </TableBody>
        </Table>
    </TableContainer>
    <div className="view-more-container">
       <Link
    to="/WagesReport"
    style={{
        textDecoration: 'none'
    }}
>
    <Button color="primary">
        VIEW MORE
    </Button>
</Link>
    </div>
	
</div>
<div className="dashboard-grid">
<div className="dashboard-table-section">

    <div className="dashboard-table-header">
        <h2 className="dashboard-table-title">
            Customer Payments
        </h2>
    </div>

    <TableContainer component={Paper}>
        <Table>

            <TableHead>
                <TableRow>

                    <TableCell>
                        <b>Sl No</b>
                    </TableCell>

                    <TableCell>
                        <b>Project</b>
                    </TableCell>

                    <TableCell align="right">
                        <b>Amount</b>
                    </TableCell>

                    <TableCell align="right">
                        <b>Paid</b>
                    </TableCell>

                    <TableCell align="right">
                        <b>Due</b>
                    </TableCell>

                </TableRow>
            </TableHead>

            <TableBody>

                {
                    this.state.customerDueData.length === 0 ?

                    <TableRow>
                        <TableCell
                            colSpan={5}
                            align="center"
                        >
                            No Records Found
                        </TableCell>
                    </TableRow>

                    :

                    this.state.customerDueData.map((item, index) => (

                        <TableRow key={index}>

                            <TableCell>
                                {index + 1}
                            </TableCell>

                            <TableCell>
                                {item.Project}
                            </TableCell>

                            <TableCell>
                                Rs. {Number(
                                    item.FinalizedAmount || 0
                                ).toLocaleString("en-IN")}
                            </TableCell>

                            <TableCell> 
                                Rs. {Number(
                                    item.PaymentIn || 0
                                ).toLocaleString("en-IN")} 
                            </TableCell>

                            <TableCell align="right"><b>
                                Rs. {Number(
                                    item.Due || 0
                                ).toLocaleString("en-IN")}</b>
                            </TableCell>

                        </TableRow>

                    ))
                }

            </TableBody>

        </Table>
    </TableContainer>

    <div className="view-more-container">
        <Link
            to="/Projectpaymentduereport"
            style={{
                textDecoration: "none"
            }}
        >
            <Button color="primary">
                VIEW MORE
            </Button>
        </Link>
    </div>

</div>
<div className="dashboard-table-section">
    <div className="dashboard-table-header">
        <h2 className="dashboard-table-title">
            Vendor Payments
        </h2>
    </div>

    <TableContainer component={Paper}>
        <Table>

            <TableHead>
                <TableRow>
                    <TableCell><b>Sl No</b></TableCell>
                    <TableCell><b>Project</b></TableCell>
                    <TableCell><b>Vendor</b></TableCell>
                    <TableCell align="right"><b>Amount</b></TableCell>
                    <TableCell align="right"><b>Paid</b></TableCell>
                    <TableCell align="right"><b>Due</b></TableCell>
                </TableRow>
            </TableHead>

            <TableBody>
                {
                    this.state.vendorPendingPayments.length === 0 ? (
                        <TableRow>
                            <TableCell colSpan={6} align="center">
                                No Records Found
                            </TableCell>
                        </TableRow>
                    ) : (
                        this.state.vendorPendingPayments.map((item, index) => (
                            <TableRow key={index}>
                                <TableCell>{index + 1}</TableCell>

                                <TableCell>
                                    {item.Project}
                                </TableCell>

                                <TableCell>
                                    {item.Vendor}
                                </TableCell>

                                <TableCell>
                                    Rs. {Number(item.Amount || 0).toLocaleString("en-IN")}
                                </TableCell>

                                <TableCell  >
                                    Rs. {Number(item.Paid || 0).toLocaleString("en-IN")}
                                </TableCell>

                                <TableCell  >
                                    <b>
                                        Rs. {Number(item.Due || 0).toLocaleString("en-IN")}
                                    </b>
                                </TableCell>
                            </TableRow>
                        ))
                    )
                }
            </TableBody>

        </Table>
    </TableContainer>

    <div className="view-more-container">
	   <Link
            to="/PendingPayments"
            style={{
                textDecoration: "none"
            }}
        >
            <Button color="primary">
                VIEW MORE
            </Button>
        </Link>

    </div>
</div>
<div className="dashboard-table-section">
  <div className="dashboard-table-header">
    <h2 className="dashboard-table-title">
      Material Procurement
    </h2>
  </div>

  <TableContainer component={Paper}>
    <Table>
      <TableHead>
        <TableRow>
		    <TableCell><b>Sl No</b></TableCell>
          <TableCell><b>Project</b></TableCell>
          <TableCell><b>Material</b></TableCell>
          <TableCell><b>Vendor</b></TableCell>
          <TableCell><b>Quantity</b></TableCell>
          <TableCell align="right"><b>Amount</b></TableCell>
        </TableRow>
      </TableHead>

      <TableBody>
        {this.state.materialPurchaseData.length === 0 ? (
          <TableRow>
            <TableCell colSpan={6} align="center">
              No Records Found
            </TableCell>
          </TableRow>
        ) : (
          this.state.materialPurchaseData.map((item, index) => (
          <TableRow key={index}>

  <TableCell>
    {index + 1}
  </TableCell>

              <TableCell>{item.ProjectName}</TableCell>
              <TableCell>{item.MaterialName}</TableCell>
              <TableCell>{item.VendorName}</TableCell>
<TableCell>
  {item.Quantity} {this.getUnitName(item.mp_units)}
</TableCell>
              <TableCell ><b>
                Rs. {Number(item.Amount || 0).toLocaleString("en-IN")}</b>
              </TableCell>

            </TableRow>
          ))
        )}
      </TableBody>
    </Table>
  </TableContainer>
   <div className="view-more-container">
	   <Link
            to="/MaterialPurchase-report"
            style={{
                textDecoration: "none"
            }}
        >
            <Button color="primary">
                VIEW MORE
            </Button>
        </Link>

    </div>
</div>
<div className="dashboard-table-section">
  <div className="dashboard-table-header">
    <h2 className="dashboard-table-title">
       Expenses
    </h2>
  </div>

  <TableContainer component={Paper}>
    <Table>

      <TableHead>
        <TableRow>
		<TableCell><b>Sl no</b></TableCell>
          <TableCell><b>Project</b></TableCell>
          <TableCell><b>Category</b></TableCell>          
          <TableCell align="right"><b>Amount</b></TableCell>
        </TableRow>
      </TableHead>

      <TableBody>
        {this.state.expenseMini.length === 0 ? (
          <TableRow>
            <TableCell colSpan={4} align="center">
              No Records Found
            </TableCell>
          </TableRow>
        ) : (
          this.state.expenseMini.map((item, i) => (
           <TableRow key={i}>

  <TableCell>
    {i + 1}
  </TableCell>
              <TableCell>{item.ProjectName}</TableCell>

              <TableCell>{item.CategoryName}</TableCell>


              <TableCell ><b>
                Rs. {Number(item.Amount || 0).toLocaleString("en-IN")}</b>
              </TableCell>

            </TableRow>
          ))
        )}
      </TableBody>

    </Table>
  </TableContainer> 
  <div className="view-more-container">
	   <Link
            to="/Expense-report"
            style={{
                textDecoration: "none"
            }}
        >
            <Button color="primary">
                VIEW MORE
            </Button>
        </Link>

    </div>
</div></div>

                </div>
            </div>
        );
    }
}